import { makeAutoObservable } from 'mobx'
import { type IEntitiesStore } from 'entities/EntitiesExport'
import { type Phone } from 'entities/Phone/model/Phone'
import { CommonNumbersStore } from 'pages/settings/pages/compliance/ui/CommonNumbers/store/commonNumbersStore'
import { type IGeneralStoreConfig } from 'pages/settings/store/newInboxSteps/newInboxCommonStepsStore'

export class AddSalesmsgNumbersStore {
  private _numbersStore: CommonNumbersStore
  private _loading = false

  constructor(private _config: IGeneralStoreConfig, private _entities: IEntitiesStore) {
    this._numbersStore = new CommonNumbersStore(
      {
        searchByNumbersOnly: true,
        setLoading: this.setLoading,
      },
      this._entities
    )
    makeAutoObservable(this)
  }

  init = (unassignedNumbers: Phone[]) => {
    this._numbersStore.init({
      unassignedNumbers: unassignedNumbers,
    })
  }

  get numbersStore() {
    return this._numbersStore
  }

  get loading() {
    return this._loading
  }

  setLoading = (value: boolean) => {
    this._loading = value
  }

  nextClickHandler = () => {
    this._config.nextClickHandler?.()
  }

  reset = () => {
    this._numbersStore.reset()
  }
}
